import { render, staticRenderFns } from "./RetourEntreprise.vue?vue&type=template&id=794f579e&"
import script from "./RetourEntreprise.vue?vue&type=script&lang=js&"
export * from "./RetourEntreprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports